module.exports = __webpack_public_path__ + "static/media/halluxguard-2.6a7eaad4.jpg";